import Modal from 'react-modal';
import styled, { css } from 'styled-components';
import { bouTextFont, getTextStyle } from '../content/texts/bou-text/text-style';
import { getTitleStyle } from '../content/texts/bou-title/title-style';
import { BouColor } from '../global/bou-colors';
import { defaultMobileBreakpointDEPRECATED, themeDEPRECATED } from '../global/styles';
import { BouSpacingLevel, fluidHorizontalPadding, fluidVerticalPadding } from '../layout/bou-spacing';
import { mobileOrNarrower } from '../layout/breakpoint-utils';
import CloseModalCrossSvg from './close-modal-cross.svg';

export const stylesOverride: Modal.Styles = {
  overlay: {
    backgroundColor: 'rgba(221,221,221,0.5)',
    zIndex: 100,
    display: 'flex',
  },
  content: {
    // border: '0px solid transparent',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '700px',
    padding: '0px',
    top: '5vh',
    maxHeight: '90vh',
    bottom: 'unset',
    fontFamily: bouTextFont,
    fontSize: 14,
    zIndex: 110,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    borderRadius: 2,
    border: `2px solid ${BouColor.TOOL_BORDER_DARK_GRAY}`,
  },
};

export const Main = styled.div<{ showOverflow?: boolean; noPadding?: boolean }>`
  ${props => !props.noPadding && fluidVerticalPadding(BouSpacingLevel.EXTRA_SMALL)}
  ${props => !props.noPadding && fluidHorizontalPadding(BouSpacingLevel.SMALL)}
  overflow: ${props => (props.showOverflow ? 'visible' : 'auto')};
  /* TODO: mobile */
  @media screen and (max-width: ${defaultMobileBreakpointDEPRECATED}px) {
    padding-left: ${themeDEPRECATED.rhythm(4)};
    padding-right: ${themeDEPRECATED.rhythm(4)};
    padding-top: ${themeDEPRECATED.rhythm(4)};
    padding-bottom: ${themeDEPRECATED.rhythm(4)};
  }
`;

export const CloseButton = styled(CloseModalCrossSvg)`
  z-index: 9999;
  cursor: pointer;
  position: absolute;
  ${getTextStyle({ size: 'medium' })};
  width: 2em;
  height: 2em;
  right: 1em;
  top: 1em;
`;

export const TitleBlock = styled.div`
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 26px;
  padding-bottom: 26px;
  border-bottom: 2px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.div`
  ${getTitleStyle({ size: 'h5' })}
  ${mobileOrNarrower(css`
    ${getTitleStyle({ size: 'h4' })}
  `)}
  color: ${BouColor.TOOL_TEXT_BLACK};
  margin-right: 40px;
`;
